 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import HTMLCOVER from '@/components/html/cover'
 import HTML01_COPYRIGH from '@/components/html/01_Copyrigh'
 import HTML00_TITLE from '@/components/html/00_Title'
 import HTML02_CONTENTS from '@/components/html/02_Contents'
 import HTML03_LIST_OF from '@/components/html/03_List_of'
 import HTML04_ACKNOWLE from '@/components/html/04_Acknowle'
 import HTML05_1_INTROD from '@/components/html/05_1_Introd'
 import HTML06_PART_ONE from '@/components/html/06_PART_ONE'
 import HTML07_2_THE_RE from '@/components/html/07_2_The_Re'
 import HTML08_3_MEDICA from '@/components/html/08_3_Medica'
 import HTML09_PART_TWO from '@/components/html/09_PART_TWO'
 import HTML10_4_ABORTI from '@/components/html/10_4_Aborti'
 import HTML11_5_THE_PO from '@/components/html/11_5_The_Po'
 import HTML12_6_POLICY from '@/components/html/12_6_Policy'
 import HTML13_7_POLITI from '@/components/html/13_7_Politi'
 import HTML14_REFERENC from '@/components/html/14_Referenc'
 import HTML15_APPENDIX from '@/components/html/15_Appendix'
 import HTML16_APPENDIX from '@/components/html/16_Appendix'
 import HTML17_APPENDIX from '@/components/html/17_Appendix'
 import HTML18_APPENDIX from '@/components/html/18_Appendix'
 import HTML19_APPENDIX from '@/components/html/19_Appendix'
 import HTML20_NOTES from '@/components/html/20_Notes'
 import HTML21_INDEX from '@/components/html/21_Index'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/html/02_Contents",
 			"name" : "html/02_Contents",
 			"component" : HTML02_CONTENTS
 		},
 		{
 			"path" : "/html/03_List_of",
 			"name" : "html/03_List_of",
 			"component" : HTML03_LIST_OF
 		},
 		{
 			"path" : "/html/04_Acknowle",
 			"name" : "html/04_Acknowle",
 			"component" : HTML04_ACKNOWLE
 		},
 		{
 			"path" : "/html/05_1_Introd",
 			"name" : "html/05_1_Introd",
 			"component" : HTML05_1_INTROD
 		},
 		{
 			"path" : "/html/06_PART_ONE",
 			"name" : "html/06_PART_ONE",
 			"component" : HTML06_PART_ONE
 		},
 		{
 			"path" : "/html/07_2_The_Re",
 			"name" : "html/07_2_The_Re",
 			"component" : HTML07_2_THE_RE
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js